import React, { memo } from "react"
import { useDisclosure } from "@chakra-ui/react"
import { graphql, useStaticQuery } from "gatsby"

import { useAppContext } from "@app/providers/app"
import { ProductStockOverlay } from "./ProductStockOverlay"
import { ProductStockToggle } from "./ProductStockToggle"

import type { ProductCombinedProps, SelectedOptionProps } from "@root/types/global"

type Props = {
  handleChange: (option: SelectedOptionProps) => void
  handleErrors: () => void
  product: ProductCombinedProps
  selectedOptions: Array<SelectedOptionProps>
}

export const ProductStock: React.FC<Props> = memo(({ handleChange, handleErrors, product, selectedOptions }) => {
  const { product: settings } = useStaticQuery<GatsbyTypes.ProductStockQuery>(graphql`
    query ProductStock {
      product: sanityTemplateProduct {
        findInStore
      }
    }
  `)
  const { activeVariant } = useAppContext()
  const { isOpen, onToggle } = useDisclosure()

  return settings?.findInStore ? (
    <>
      <ProductStockToggle activeVariant={activeVariant} handleErrors={handleErrors} handleToggle={onToggle} />
      {activeVariant?.sku && (
        <ProductStockOverlay
          handleChange={handleChange}
          handleToggle={onToggle}
          isOpen={isOpen}
          product={product}
          selectedOptions={selectedOptions}
          variant={activeVariant}
        />
      )}
    </>
  ) : null
})
